export const Notary = {
    address: '0xa3811BFB277e03ac57B28e66F5802C3972FaDAB4',
};
